"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _glamor = require("glamor");

var _classnames = _interopRequireDefault(require("classnames"));

var _react = _interopRequireDefault(require("react"));

var _Context = _interopRequireDefault(require("./Context"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var ROOT_CSS = (0, _glamor.css)({
  boxSizing: 'border-box'
});

var _default = function _default(_ref) {
  var className = _ref.className,
      handlerClassName = _ref.handlerClassName;
  return _react.default.createElement(_Context.default.Consumer, null, function (_ref2) {
    var scrollBarPercentage = _ref2.scrollBarPercentage,
        scrollBarWidth = _ref2.scrollBarWidth;
    return _react.default.createElement("div", {
      className: (0, _classnames.default)(ROOT_CSS + '', className)
    }, _react.default.createElement("div", {
      className: handlerClassName,
      style: {
        marginLeft: "".concat((1 - parseFloat(scrollBarWidth) / 100) * parseFloat(scrollBarPercentage), "%"),
        width: scrollBarWidth
      }
    }));
  });
};

exports.default = _default;